import { Component, EventEmitter } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as saveAs from 'file-saver';
import { firstValueFrom } from 'rxjs';
import { Provider, ProviderWarehouse } from 'src/typings';
import { ProviderPriceService } from '../provider-price.service';
import { UploadResultComponent } from '../upload-result/upload-result.component';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent {
  selectedFile: File | undefined;

  loading: boolean = false;

  doneEvent = new EventEmitter();

  formGroup = this.fb.group({
    provider: new UntypedFormControl(),
    price_column: new UntypedFormControl(),
    description_column: new UntypedFormControl(),
    article_column: new UntypedFormControl(),
    brand_column: new UntypedFormControl(),
    delimiter: new UntypedFormControl(';'),
    wh_array: this.fb.array([])
  });

  get whArray() {
    return this.formGroup.controls.wh_array as UntypedFormArray;
  }

  get providerControl() {
    return this.formGroup.controls.provider as UntypedFormControl;
  }

  get priceControl() {
    return this.formGroup.controls.price_column as UntypedFormControl;
  }

  get delimiterControl() {
    return this.formGroup.controls.delimiter as UntypedFormControl;
  }

  get articleControl() {
    return this.formGroup.controls.article_column as UntypedFormControl;
  }

  get descriptionControl() {
    return this.formGroup.controls.description_column as UntypedFormControl;
  }

  get brandControl() {
    return this.formGroup.controls.brand_column as UntypedFormControl;
  }

  constructor(
    private dialog: MatDialog,
    private providerPriceService: ProviderPriceService,
    private fb: UntypedFormBuilder
  ) {
    this.providerControl.valueChanges.subscribe((provider) => {
      console.log(provider);
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { price_column, description_column, article_column, brand_column } =
        this.formGroup.controls;
      price_column.setValue(provider.uploadPrice);
      description_column.setValue(provider.uploadDescription);
      article_column.setValue(provider.uploadArticle);
      brand_column.setValue(provider.uploadBrand);
      if (typeof provider == 'object') {
        this.loadWarehouses();
      }
    });
  }

  loadWarehouses() {
    const provider: Provider = this.providerControl.value;
    this.whArray.clear();
    provider.providerWarehouse?.forEach((wh) => {
      this.whArray.push(this.fb.group({ wh, column: new UntypedFormControl(wh.description) }));
    });
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files.item(0);
    return;
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'application/vnd.ms.excel' });
    const file = new File([blob], 'not_found.xlsx', { type: 'application/vnd.ms.excel' });
    saveAs(file);
  }

  async upload() {
    if (!this.selectedFile) return window.alert('Файл не выбран!');
    // if (!this.providerControl.value) return window.alert('Поставщик не выбран!');
    // if (!this.articleControl.value || !this.brandControl.value || !this.priceControl.value)
    //   return window.alert('Не все данные заполнены!');
    this.loading = true;
    const warehouses = this.whArray.value.map((row: { wh: ProviderWarehouse; column: string }) => {
      return {
        wh_id: row.wh.id,
        column: row.column
      };
    });
    try {
      await firstValueFrom(
        this.providerPriceService.uploadPriceFile({
          file: this.selectedFile,
          provider_id: this.providerControl.value.id,
          description_column: this.descriptionControl.value,
          article_column: this.articleControl.value,
          brand_column: this.brandControl.value,
          price_column: this.priceControl.value,
          delimiter: this.delimiterControl.value,
          warehouses
        })
      );
    } catch (err) {
      window.alert(err);
    }
    this.loading = false;

    this.openResultDialog();

    this.doneEvent.emit();
    return;
  }

  openResultDialog() {
    return this.dialog.open(UploadResultComponent);
  }
}
